import React from 'react';
import { Box, NavigationToggler, Text } from '@common-fe/common-fe';

import { useFilters } from '@/utils';

import { ReportTab } from '../../report.types';
import { useGetReportEmployerId } from '../../ReportDetails/hooks';
import AddScheduledReportButton from '../AddScheduledReportButton';

import ScheduledReportsInboxTab from './ScheduledReportsInboxTab';
import ScheduledReportsTab from './ScheduledReportsTab';

export enum ScheduledReportsTabs {
  Inbox = 'Inbox',
  Schedule = 'Schedule',
}
interface FiltersValues {
  tab: ScheduledReportsTabs | string;
}
const ScheduledReports = () => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      tab: ScheduledReportsTabs.Schedule,
    },
    {
      autoClear: true,
    }
  );

  return (
    <Box direction="column">
      <Box direction="row" justify="between">
        <Text size="3xl" weight={700}>
          Scheduled Reports
        </Text>
        <Box direction="row" align="center">
          <Box margin={{ right: 'spacing24' }}>
            <AddScheduledReportButton isStandAloneMode employerId={employerId} tab={ReportTab.Report} />
          </Box>
          <NavigationToggler
            value={filtersValues.tab}
            options={[
              {
                key: ScheduledReportsTabs.Inbox,
                title: 'Inbox',
              },
              {
                key: ScheduledReportsTabs.Schedule,
                title: 'Schedules',
              },
            ]}
            onChange={(key) => setFilterValue.tab(key as ScheduledReportsTabs)}
          />
        </Box>
      </Box>
      <Box pad={{ top: 'spacing24' }}>
        {filtersValues.tab === ScheduledReportsTabs.Inbox ? (
          <ScheduledReportsInboxTab />
        ) : (
          <ScheduledReportsTab />
        )}
      </Box>
    </Box>
  );
};

export default ScheduledReports;
